const link = [
    {
        title:'首页',
        list:[],
        height:0,
        component:'Home'
    },
    {
        title:'公司概况',
        component:'Introduction',
        height:0,
        list:[
            {
                title:"公司简介",
                en:"COMPANY PROFILE",
                component:'Introduction',
                type:1
            },
            // {
            //     title:"集团组织架构",
            //     en:"GROUP ORGANIZATION STRUCTURE",
            //     component:'Introduction',
            //     type:2
            // },
            // {
            //     title:"集团党支部",
            //     en:"GROUP PARTY BRANCH",
            //     component:'Introduction',
            //     type:3
            // },
            // {
            //     title:"集团荣誉",
            //     en:"GROUP HONOR",
            //     component:'Introduction',
            //     type:4
            // },
            // {
            //     title:"集团领导",
            //     en:"GROUP LEADER",
            //     component:'Introduction',
            //     type:5
            // }
        ]
    },
    {
        title:'新闻中心',
        component:'News',
        height:0,
        list:[
            {
                title:"通知中心",
                component:'NewsList',
                type:1
            },
            {
                title:"新闻动态",
                component:'NewsList',
                type:2
            },
            {
                title:"行业资讯",
                component:'NewsList',
                type:3
            }
        ]
    },
    {
        title:'养老类目',
        component:'Department',
        height:0,
        list:[
            {
                title:"居家养老",
                en:"Home care for the elderly",
                component:'DepartmentList',
                type:1
            },
            {
                title:"机构养老",
                en:"Institutional elderly care",
                component:'DepartmentList',
                type:2
            },
            {
                title:"智慧养老",
                en:"Smart Elderly Care",
                component:'DepartmentList',
                type:3
            },
            {
                title:"文化养老",
                en:"Cultural Elderly Care",
                component:'DepartmentList',
                type:4
            },{
                title:"老年食堂",
                en:"Elderly canteen",
                component:'DepartmentList',
                type:8
            }
        ]
    },
    {
        title:'养老百科',
        component:'EncyclopediaList',
        height:0,
        list:[
            {
                title:"养生护理",
                component:'EncyclopediaList',
                type:1
            },
            {
                title:"心理健康",
                component:'EncyclopediaList',
                type:2
            },
            {
                title:"饮食推荐",
                component:'EncyclopediaList',
                type:3
            },
            {
                title:"运动健身",
                component:'EncyclopediaList',
                type:4
            }
        ]
    },
    {
        title:'联系我们',
        component:'Contact',
        height:0,
        list:[]
    }
]
export default link



// WEBPACK FOOTER //
// ./src/link.js